module.exports = __webpack_public_path__ + "static/media/android.0eada50a.svg";